import PropTypes from "prop-types";

import Presenter from "utils/PropTypesPresenter";

export default new Presenter({
  id: PropTypes.string,
  name: PropTypes.string,
  titleFont: PropTypes.string,
  titleFontColor: PropTypes.string,
  hostLabelFont: PropTypes.string,
  hostLabelFontColor: PropTypes.string,
  hostFont: PropTypes.string,
  hostFontColor: PropTypes.string,
  descriptionFont: PropTypes.string,
  descriptionFontColor: PropTypes.string,
  locationLabelFont: PropTypes.string,
  locationLabelFontColor: PropTypes.string,
  locationFont: PropTypes.string,
  locationFontColor: PropTypes.string,
  dateLabelFont: PropTypes.string,
  dateLabelFontColor: PropTypes.string,
  dateFont: PropTypes.string,
  dateFontColor: PropTypes.string,
  guestListFont: PropTypes.string,
  guestListFontColor: PropTypes.string,
  invitationBackgroundColor: PropTypes.string,
  guestListBackgroundColor: PropTypes.string,
  eventDetailsBackgroundColor: PropTypes.string,
  invitationBorderColor: PropTypes.string,
});
